export var BUName;
(function (BUName) {
    BUName["Marcas"] = "Marcas";
    BUName["NeoQuimica"] = "Neo Qu\u00EDmica";
})(BUName || (BUName = {}));
export var BusinessUnitResponseEnum;
(function (BusinessUnitResponseEnum) {
    BusinessUnitResponseEnum["BusinessUnitId"] = "businessUnitId";
    BusinessUnitResponseEnum["BusinessUnitName"] = "businessUnitName";
    BusinessUnitResponseEnum["Distributors"] = "distributors";
    BusinessUnitResponseEnum["IsPED"] = "pedEnabled";
})(BusinessUnitResponseEnum || (BusinessUnitResponseEnum = {}));
export var RoleTypes;
(function (RoleTypes) {
    RoleTypes["OWNER"] = "OWNER";
    RoleTypes["BUYER"] = "BUYER";
    RoleTypes["SUPERVISOR"] = "SUPERVISOR";
})(RoleTypes || (RoleTypes = {}));
//# sourceMappingURL=pos.js.map